import { render, staticRenderFns } from "./Empolyee.vue?vue&type=template&id=1a970b1a&scoped=true"
import script from "./Empolyee.vue?vue&type=script&lang=js"
export * from "./Empolyee.vue?vue&type=script&lang=js"
import style0 from "./Empolyee.vue?vue&type=style&index=0&id=1a970b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a970b1a",
  null
  
)

export default component.exports